// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-module--modal--2SNGh","overlay":"modal-module--overlay--2WYpq","closeBtn":"modal-module--closeBtn--2IMSZ"};